import { Box, Flex, Image, Grid, GridItem } from '@chakra-ui/react';
import { NavLink, useParams, useNavigate } from 'react-router-dom';
import WorkspaceMenu from './workspace-menu';
import NavigationMenu from './navigation-menu';
import UserMenu from './user-menu';
import { useAuth } from '@/lib/hooks/use-auth';
import useWorkspace from '@/lib/hooks/use-workspace';
import { useScrollState } from '@/lib/hooks/use-scroll-state';

export default function Navigation() {
  const { workspaceId } = useParams();
  const { workspace } = useWorkspace();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const isScroll = useScrollState();

  const handleLogout = () => {
    logout();
    navigate('/auth/login');
  };

  return (
    <Flex
      as={'header'}
      justifyContent={'space-between'}
      alignItems={'center'}
      w={'full'}
      position={'sticky'}
      top={0}
      left={0}
      right={0}
      zIndex={11}
      px={{ base: 2, md: 4 }}
      boxShadow={isScroll ? 'sm' : ''}
      transition={'box-shadow 0.2s ease 0s'}
      backdropFilter={'blur(100px)'}
    >
      <Box mr={2}>
        {workspace && (
          <NavLink to={`/${workspaceId}/home`}>
            <Box display={{ base: 'none', xl: 'block' }}>
              <Image
                src={workspace?.logo || '/logo_horizontal.png'}
                alt={workspace?.name || 'Coach Hub'}
                height={'32px'}
                fit='contain'
              />
            </Box>
            <Box display={{ base: 'block', xl: 'none' }}>
              <Image
                src={workspace?.logo || '/logo.png'}
                alt={workspace?.name || 'Coach Hub'}
                h={6}
              />
            </Box>
          </NavLink>
        )}
      </Box>
      <Grid templateColumns={{ lg: 'auto 1fr auto' }} pr={{ base: 2, md: 4 }} py={2} w={'full'}>
        <GridItem gridRow={1} gridColumn={1}>
          <WorkspaceMenu currentWorkspaceId={workspaceId} />
        </GridItem>
        <GridItem
          gridRow={1}
          gridColumn={2}
          display={'flex'}
          gridColumnStart={{ lg: 1 }}
          gridColumnEnd={{ lg: -1 }}
          justifyContent={{ lg: 'center' }}
        >
          <Flex justifyContent='center'>
            <NavigationMenu />
          </Flex>
        </GridItem>
        <GridItem gridRow={1} gridColumn={3}>
          <UserMenu workspaceId={workspaceId} handleLogout={handleLogout} />
        </GridItem>
      </Grid>
    </Flex>
  );
}
